import { useMFEContext } from '~/components/MFEProvider';

interface BrandInfo {
  phoneNumberFormatted: string;
  phoneNumberHref: string;
  isDNSManagedInCpanel: boolean;
  supportLink: string;
  contactLink: string;
  renewalCenterLink: string;
  multisiteLearnMoreUrl?: string;
}

interface DefaultBrandInfo extends BrandInfo {
  domainName: string;
  path: string;
  optimizeLink: string;
  wpSolutionLearnMoreUrl: string;
  loggingInUsingExtClient: string;
  basicSSHCommands: string;
  commonSSHErrors: string;
  generateSSHPublicKeyUrl: string;
  indexesLearnMoreUrl: string;
  directoryPrivacyLearnMoreUrl: string;
  redirectsLearnMoreUrl: string;
  diskUsageLearnMoreUrl: string;
  phpInfoLearnMoreUrl: string;
  dbInfoLearnMoreUrl: string;
  cronJobLearnMoreUrl: string;
  remoteMySQLLearnMoreUrl: string;
  ipblockerLearnMoreUrl: string;
  cloudStagingKb: string;
  cloudStagingPromoteKb: string;
  cloudStagingDeleteKb: string;
  cloudCachingUrl: string;
  visitorInfoLearnMoreUrl: string;
  ftpLearnMoreUrl: string;
  cloudFlareKB: string;
  checkDatabaseLearnMoreUrl: string;
  repairDatabaseLearnMoreUrl: string;
  sslLearnMoreUrl: string;
  pageSpeedInsightsLearnMoreKb: string;
  emailAccountsLearnMoreUrl: string;
  emailAccountForwardersLearnMoreUrl: string;
  domainForwardersLearnMoreUrl: string;
  advancedDNSManagementUrl: string;
  phpErrorLogLearnMoreUrl: string;
  hotLinkProtectionLearnMoreUrl: string;
  removeWpStagingSiteLearnMoreUrl: string;
  emailFiltersLearnMoreUrl: string;
  globalEmailFiltersLearnMoreUrl: string;
  repairDocrootMismatchLearnMoreUrl: string;
  accessLogsLearnMoreUrl: string;
  whoIsLink?: string;
  contactSupportRestoreUrl: string;
  emailDiskUsageLearnMoreUrl: string;
  fixFileOwnershipLearnMoreUrl: string;
  learnMoreMailClientSetup: string;
  sitesCapabilitiesLearnMoreUrl: string;
  howToArticleUrl?: string;
  howToWebsitesArticleUrl?: string;
  howToWebsitesAIArticleUrl?: string;
  howToWebsitesVideoArticleUrl?: string;
  howToHostingArticleUrl?: string;
  purchaseDomainUrl: string;
  insightsArticleUrl?: string;
  insightsTalkToOurTeamUrl?: string;
  marketPlaceUrl?: string;
  xSellProdUrl?: string;
  xSellQaUrl?: string;
  spamFiltersLearnMoreUrl?: string;
  sharedHostingUrl?: string;
  vpsHostingUrl?: string;
  dediHostingUrl?: string;
  cloudHostingUrl?: string;
  aiSiteUpgradeUrl: string;
  usersArticleUrl?: string;
  xcitiumArticleUrl?: string;
  securityArticleUrl?: string;
  vpsOverviewArticleUrl?: string;
  dediOverviewArticleUrl?: string;
  aiSiteArticleUrl?: string;
  aiStoreArticleUrl?: string;
  aiSitePurchaseUrl?: string;
  aiStorePurchaseUrl?: string;
  gatorClawAiCreditArticleUrl?: string;
  openClawAiCreditArticleUrl?: string;
  claudeCodeAiCreditArticleUrl?: string;
  hermesAiCreditArticleUrl?: string;
  nanoClawAiCreditArticleUrl?: string;
  purchaseAiCreditArticleUrl?: string;
  bluehostAPIKeysArticleUrl?: string;
  understandAiCreditArticleUrl?: string;
  aiModalCreditPricingArticleUrl?: string;
}

interface BluehostBrandInfo extends BrandInfo {
  domainName: string;
  path: string;
  optimizeLink: string;
  wpSolutionLearnMoreUrl: string;
  loggingInUsingExtClient: string;
  basicSSHCommands: string;
  commonSSHErrors: string;
  generateSSHPublicKeyUrl: string;
  indexesLearnMoreUrl: string;
  directoryPrivacyLearnMoreUrl: string;
  redirectsLearnMoreUrl: string;
  diskUsageLearnMoreUrl: string;
  phpInfoLearnMoreUrl: string;
  dbInfoLearnMoreUrl: string;
  cronJobLearnMoreUrl: string;
  remoteMySQLLearnMoreUrl: string;
  ipblockerLearnMoreUrl: string;
  cloudStagingKb: string;
  cloudStagingPromoteKb: string;
  cloudStagingDeleteKb: string;
  cloudCachingUrl: string;
  visitorInfoLearnMoreUrl: string;
  ftpLearnMoreUrl: string;
  cloudFlareKB: string;
  checkDatabaseLearnMoreUrl: string;
  repairDatabaseLearnMoreUrl: string;
  sslLearnMoreUrl: string;
  pageSpeedInsightsLearnMoreKb: string;
  emailAccountForwardersLearnMoreUrl: string;
  advancedDNSManagementUrl: string;
  removeWpStagingSiteLearnMoreUrl: string;
  emailFiltersLearnMoreUrl: string;
  globalEmailFiltersLearnMoreUrl: string;
  repairDocrootMismatchLearnMoreUrl: string;
  phpErrorLogLearnMoreUrl: string;
  hotLinkProtectionLearnMoreUrl: string;
  accessLogsLearnMoreUrl: string;
  contactSupportRestoreUrl: string;
  emailDiskUsageLearnMoreUrl: string;
  whoIsLink: string;
  fixFileOwnershipLearnMoreUrl: string;
  sitesCapabilitiesLearnMoreUrl: string;
  howToArticleUrl?: string;
  howToWebsitesArticleUrl?: string;
  howToWebsitesAIArticleUrl?: string;
  howToWebsitesVideoArticleUrl?: string;
  howToHostingArticleUrl?: string;
  purchaseDomainUrl?: string;
  multisiteLearnMoreUrl?: string;
  insightsArticleUrl?: string;
  insightsTalkToOurTeamUrl?: string;
  marketPlaceUrl?: string;
  xSellProdUrl?: string;
  xSellQaUrl?: string;
  spamFiltersLearnMoreUrl?: string;
  sharedHostingUrl?: string;
  vpsHostingUrl?: string;
  dediHostingUrl?: string;
  cloudHostingUrl?: string;
  aiSiteUpgradeUrl?: string;
  aiSiteArticleUrl?: string;
  aiStoreArticleUrl?: string;
  aiSitePurchaseUrl?: string;
  aiStorePurchaseUrl?: string;
  gatorClawAiCreditArticleUrl?: string;
  openClawAiCreditArticleUrl?: string;
  claudeCodeAiCreditArticleUrl?: string;
  hermesAiCreditArticleUrl?: string;
  nanoClawAiCreditArticleUrl?: string;
  purchaseAiCreditArticleUrl?: string;
  bluehostAPIKeysArticleUrl?: string;
  understandAiCreditArticleUrl?: string;
  aiModalCreditPricingArticleUrl?: string;
}

interface HostgatorBrandInfo extends BrandInfo {
  optimizeLink: string;
  loggingInUsingExtClient: string;
  basicSSHCommands: string;
  commonSSHErrors: string;
  cloudFlareKB: string;
  generateSSHPublicKeyUrl: string;
  indexesLearnMoreUrl: string;
  directoryPrivacyLearnMoreUrl: string;
  redirectsLearnMoreUrl: string;
  diskUsageLearnMoreUrl: string;
  dbInfoLearnMoreUrl: string;
  cronJobLearnMoreUrl: string;
  remoteMySQLLearnMoreUrl: string;
  ipblockerLearnMoreUrl: string;
  ftpLearnMoreUrl: string;
  checkDatabaseLearnMoreUrl: string;
  repairDatabaseLearnMoreUrl: string;
  sslLearnMoreUrl: string;
  visitorInfoLearnMoreUrl: string;
  phpInfoLearnMoreUrl: string;
  pageSpeedInsightsLearnMoreKb: string;
  emailAccountForwardersLearnMoreUrl: string;
  removeWpStagingSiteLearnMoreUrl: string;
  advancedDNSManagementUrl: string;
  repairDocrootMismatchLearnMoreUrl: string;
  hotLinkProtectionLearnMoreUrl: string;
  accessLogsLearnMoreUrl: string;
  whoIsLink: string;
  contactSupportRestoreUrl: string;
  phpErrorLogLearnMoreUrl: string;
  fixFileOwnershipLearnMoreUrl: string;
  sitesCapabilitiesLearnMoreUrl: string;
  howToHostingArticleUrl: string;
  howToArticleUrl: string;
  marketPlaceUrl: string;
  xSellProdUrl?: string;
  xSellQaUrl?: string;
  insightsTalkToOurTeamUrl: string;
  sharedHostingUrl: string;
  vpsHostingUrl: string;
  dediHostingUrl: string;
  cloudHostingUrl: string;
  insightsArticleUrl: string;
  usersArticleUrl: string;
  xcitiumArticleUrl: string;
  securityArticleUrl: string;
  vpsOverviewArticleUrl: string;
  dediOverviewArticleUrl: string;
  openClawAiCreditArticleUrl: string;
  claudeCodeAiCreditArticleUrl: string;
  hermesAiCreditArticleUrl: string;
  nanoClawAiCreditArticleUrl: string;
  gatorClawAiCreditArticleUrl: string;
  purchaseAiCreditArticleUrl: string;
  bluehostAPIKeysArticleUrl: string;
  understandAiCreditArticleUrl: string;
  aiModalCreditPricingArticleUrl?: string;
}

// TODO: ideally this is passed from host application
// or managed in a service or endpoint of its own
export const brands: {
  default: DefaultBrandInfo;
  bluehost: BluehostBrandInfo;
  hostgator: HostgatorBrandInfo;
  bluehost_in: BluehostBrandInfo;
} = {
  default: {
    phoneNumberFormatted: '',
    phoneNumberHref: '',
    isDNSManagedInCpanel: false,
    domainName: '',
    path: '',
    contactLink: '',
    renewalCenterLink: '',
    optimizeLink: '',
    supportLink: '',
    wpSolutionLearnMoreUrl: '',
    loggingInUsingExtClient: '',
    basicSSHCommands: '',
    commonSSHErrors: '',
    generateSSHPublicKeyUrl: '',
    indexesLearnMoreUrl: '',
    directoryPrivacyLearnMoreUrl: '',
    redirectsLearnMoreUrl: '',
    diskUsageLearnMoreUrl: '',
    phpInfoLearnMoreUrl: '',
    dbInfoLearnMoreUrl: '',
    cronJobLearnMoreUrl: '',
    remoteMySQLLearnMoreUrl: '',
    ipblockerLearnMoreUrl: '',
    cloudStagingKb: '',
    cloudStagingPromoteKb: '',
    cloudStagingDeleteKb: '',
    cloudCachingUrl: '',
    visitorInfoLearnMoreUrl: '',
    ftpLearnMoreUrl: '',
    cloudFlareKB: '',
    checkDatabaseLearnMoreUrl: '',
    repairDatabaseLearnMoreUrl: '',
    sslLearnMoreUrl: '',
    pageSpeedInsightsLearnMoreKb: '',
    emailAccountsLearnMoreUrl: '',
    emailAccountForwardersLearnMoreUrl: '',
    domainForwardersLearnMoreUrl: '',
    removeWpStagingSiteLearnMoreUrl: '',
    advancedDNSManagementUrl: '',
    phpErrorLogLearnMoreUrl: '',
    hotLinkProtectionLearnMoreUrl: '',
    emailFiltersLearnMoreUrl: '',
    globalEmailFiltersLearnMoreUrl: '',
    repairDocrootMismatchLearnMoreUrl: '',
    accessLogsLearnMoreUrl: '',
    contactSupportRestoreUrl: '',
    emailDiskUsageLearnMoreUrl: '',
    fixFileOwnershipLearnMoreUrl: '',
    learnMoreMailClientSetup: '',
    sitesCapabilitiesLearnMoreUrl: '',
    purchaseDomainUrl: '',
    multisiteLearnMoreUrl: '',
    insightsArticleUrl: '',
    insightsTalkToOurTeamUrl: '',
    marketPlaceUrl: '',
    spamFiltersLearnMoreUrl: '',
    sharedHostingUrl: '',
    vpsHostingUrl: '',
    dediHostingUrl: '',
    cloudHostingUrl: '',
    aiSiteUpgradeUrl: '',
    aiSiteArticleUrl: '',
    aiSitePurchaseUrl: '',
    aiStorePurchaseUrl: '',
    openClawAiCreditArticleUrl: '',
    claudeCodeAiCreditArticleUrl: '',
    hermesAiCreditArticleUrl: '',
    nanoClawAiCreditArticleUrl: '',
    gatorClawAiCreditArticleUrl: '',
    purchaseAiCreditArticleUrl: '',
    bluehostAPIKeysArticleUrl: '',
    understandAiCreditArticleUrl: '',
    aiModalCreditPricingArticleUrl: '',
  },
  bluehost: {
    phoneNumberFormatted: '1-888-401-4678',
    phoneNumberHref: 'tel:+18884014678',
    isDNSManagedInCpanel: true,
    domainName: 'www.bluehost.com',
    path: 'Bluehost%20Cloud',
    contactLink: 'https://www.bluehost.com/contact',
    renewalCenterLink: 'https://www.bluehost.com/my-account/billing-center-v2',
    optimizeLink:
      'https://www.bluehost.com/help/article/optimize-hosting-reduce-disk-space',
    supportLink: 'https://www.bluehost.com/contact',
    wpSolutionLearnMoreUrl: 'https://www.bluehost.com',
    loggingInUsingExtClient:
      'https://www.bluehost.com/help/article/ssh-connections',
    basicSSHCommands: 'https://www.bluehost.com/help/article/ssh-commands',
    commonSSHErrors: 'https://www.bluehost.com/help/article/common-ssh-errors',
    generateSSHPublicKeyUrl:
      'https://www.bluehost.com/help/article/generate-ssh-keys#windows-with-putty',
    indexesLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-index-manager',
    directoryPrivacyLearnMoreUrl:
      'https://www.bluehost.com/help/article/password-protect-a-folder-on-your-website',
    redirectsLearnMoreUrl:
      'https://www.bluehost.com/help/article/redirect-a-domain',
    diskUsageLearnMoreUrl:
      'https://www.bluehost.com/help/article/disk-space-bandwidth-usage',
    phpInfoLearnMoreUrl: 'https://www.bluehost.com/help/article/am-php-info',
    dbInfoLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-database-manager#create-mysql-db',
    cronJobLearnMoreUrl:
      'https://www.bluehost.com/help/article/cron-job-basics',
    remoteMySQLLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-remote-mysql',
    ipblockerLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-ip-blocker',
    cloudStagingKb: 'https://www.bluehost.com/help/article/bh-cloud-staging',
    cloudStagingPromoteKb:
      'https://www.bluehost.com/help/article/bh-cloud-promoting-a-staging-site',
    cloudStagingDeleteKb:
      'https://www.bluehost.com/help/article/bh-cloud-remove-or-delete-a-staging-site',
    cloudCachingUrl: 'https://www.bluehost.com/help/article/bh-cloud-caching',
    ftpLearnMoreUrl:
      'https://www.bluehost.com/help/article/create-and-manage-ftp-accounts-for-your-website',
    cloudFlareKB: 'https://www.bluehost.com/help/article/cloudflare-enable-cdn',
    checkDatabaseLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-check-repair-and-optimize-database-in-account-manager',
    repairDatabaseLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-check-repair-and-optimize-database-in-account-manager',
    sslLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-how-to-manually-install-ssl-in-account-manager',
    visitorInfoLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-viewing-visitor-stats',
    pageSpeedInsightsLearnMoreKb:
      'https://www.bluehost.com/help/article/am-pagespeed-insights',
    emailAccountForwardersLearnMoreUrl:
      'https://www.bluehost.com/help/article/create-account-and-domain-forwarders',
    phpErrorLogLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-php-errors',
    hotLinkProtectionLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-hotlink-protection',
    removeWpStagingSiteLearnMoreUrl:
      'https://www.bluehost.com/help/article/uninstall-wordpress#remove-staging-site',
    advancedDNSManagementUrl: '',
    emailFiltersLearnMoreUrl: '',
    globalEmailFiltersLearnMoreUrl: '',
    repairDocrootMismatchLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-website-misconfiguration-error',
    accessLogsLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-access-logs',
    whoIsLink: 'https://www.bluehost.com/whois/index.jsp',
    contactSupportRestoreUrl: 'https://www.bluehost.com/contact',
    emailDiskUsageLearnMoreUrl: '',
    fixFileOwnershipLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-fix-file-ownership',
    sitesCapabilitiesLearnMoreUrl:
      'https://www.bluehost.com/help/article/virtual-private-server-vps-hosting-prices',
    howToArticleUrl: 'https://www.bluehost.com/help',
    howToWebsitesArticleUrl:
      'https://www.bluehost.com/blog/latest-wordpress-version-6-9/',
    howToWebsitesAIArticleUrl:
      'https://www.bluehost.com/help/article/bluehost-ai-website-builder-overview',
    howToWebsitesVideoArticleUrl:
      'https://www.bluehost.com/help/article/am-account-manager-updates',
    howToHostingArticleUrl:
      'https://www.bluehost.com/help/article/bh-general-website-troubleshooting',
    purchaseDomainUrl:
      'https://www.bluehost.com/domains?channelId=P13C100S1N0B3003A151D115E0000V119',
    multisiteLearnMoreUrl:
      'https://www.bluehost.com/help/article/bh-wordpress-multisite-when-to-use',
    insightsArticleUrl:
      'https://www.bluehost.com/help/article/bh-portal-website-insights',
    insightsTalkToOurTeamUrl: 'https://www.bluehost.com/full-service-seo',
    marketPlaceUrl:
      'https://www.bluehost.com/web-hosting?channelid=P61C100S1N0B3003A151D115E0000V109#pricing-cards',
    xSellProdUrl: 'https://adam.bluehost.com/api/v1/getXSell',
    xSellQaUrl:
      'https://global-nfd-nfd-adserver-bh.apps.atlanta1.newfoldmb.com/api/v1/getXSell',
    spamFiltersLearnMoreUrl:
      'https://www.bluehost.com/help/article/spam-filters',
    sharedHostingUrl: 'https://www.bluehost.com/hosting/shared',
    vpsHostingUrl: 'https://www.bluehost.com/hosting/vps',
    dediHostingUrl: 'https://www.bluehost.com/hosting/dedicated',
    cloudHostingUrl: 'https://www.bluehost.com/hosting/cloud',
    aiSiteUpgradeUrl: 'https://www.bluehost.com/checkout/ai-builder/publish',
    aiSiteArticleUrl:
      'https://www.bluehost.com/help/article/video-bh-ai-website-builder-tutorials',
    aiStoreArticleUrl:
      'https://www.bluehost.com/help/article/bh-ai-store-navigate-dashboard',
    aiSitePurchaseUrl: 'https://www.bluehost.com/ai-website-builder',
    aiStorePurchaseUrl: 'https://www.bluehost.com/ai-store',
    openClawAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-connect-ai-credits-to-openclaw',
    claudeCodeAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-connect-ai-credits-to-claude-code',
    hermesAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-connect-ai-credits-to-hermes',
    nanoClawAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-connect-ai-credits-to-nanoclaw',
    gatorClawAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-connect-ai-credits-to-gatorclaw',
    purchaseAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-purchase-ai-credits',
    bluehostAPIKeysArticleUrl:
      'https://www.bluehost.com/help/article/bh-manage-and-create-api-keys',
    understandAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-understanding-ai-credits',
    aiModalCreditPricingArticleUrl:
      'https://www.bluehost.com/help/article/bh-ai-models-and-credit-pricing',
  },
  hostgator: {
    phoneNumberFormatted: '1-866-964-2867',
    phoneNumberHref: 'tel:+18669642867',
    isDNSManagedInCpanel: true,
    supportLink: 'https://www.hostgator.com/contact',
    //domainName and path not implemented, since Hostgator does not yet support Atomic
    contactLink: 'https://www.hostgator.com/contact',
    renewalCenterLink: '',
    cloudFlareKB: '',
    optimizeLink:
      'https://www.hostgator.com/help/article/optimize-and-free-up-hosting-disk-space',
    loggingInUsingExtClient:
      'https://www.hostgator.com/help/article/ssh-keying-through-putty-on-windows-or-linux',
    basicSSHCommands: 'https://www.hostgator.com/help/article/shell-commands',
    commonSSHErrors: 'https://www.hostgator.com/help/article/ssh-errors',
    generateSSHPublicKeyUrl:
      'https://www.hostgator.com/help/article/ssh-keying-through-putty-on-windows-or-linux',
    indexesLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-index-manager',
    directoryPrivacyLearnMoreUrl:
      'https://www.hostgator.com/help/article/how-to-edit-your-htaccess-file',
    redirectsLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-redirects',
    diskUsageLearnMoreUrl:
      'https://www.hostgator.com/help/article/how-can-i-view-disk-space-and-bandwidth-usage-for-my-shared-account',
    dbInfoLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-database-manager',
    cronJobLearnMoreUrl: 'https://www.hostgator.com/help/article/cp-cron-job',
    remoteMySQLLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-remote-mysql',
    ipblockerLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-ip-blocker',
    ftpLearnMoreUrl: 'https://hostgator.com/help/article/cp-ftp-management',
    checkDatabaseLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-check-repair-and-optimize-database-in-account-manager',
    repairDatabaseLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-check-repair-and-optimize-database-in-account-manager',
    sslLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-how-to-manually-install-ssl-in-customer-portal',
    visitorInfoLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-viewing-visitor-stats',
    phpInfoLearnMoreUrl: 'https://www.hostgator.com/help/article/cp-php-info',
    pageSpeedInsightsLearnMoreKb:
      'https://www.hostgator.com/help/article/cp-pagespeed-insights',
    emailAccountForwardersLearnMoreUrl:
      'https://www.hostgator.com/help/article/how-to-createdelete-an-email-forwarder-in-cpanel',
    hotLinkProtectionLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-hotlink-protection',
    removeWpStagingSiteLearnMoreUrl:
      'https://www.hostgator.com/help/article/how-to-uninstall-wordpress-site#remove-staging-site',
    advancedDNSManagementUrl: '',
    phpErrorLogLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-php-errors',
    repairDocrootMismatchLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-website-misconfiguration-error',
    accessLogsLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-access-logs',
    whoIsLink: 'https://www.hostgator.com/whois/index.jsp',
    contactSupportRestoreUrl: '',
    fixFileOwnershipLearnMoreUrl:
      'https://www.hostgator.com/help/article/cp-fix-file-ownership',
    sitesCapabilitiesLearnMoreUrl: '',
    howToHostingArticleUrl:
      'https://www.hostgator.com/help/article/customer-portal-navigating-the-hosting-tab',
    howToArticleUrl: 'https://www.hostgator.com/help',
    marketPlaceUrl: 'https://www.hostgator.com/my-account/market-place',
    xSellProdUrl: 'https://adam.bluehost.com/api/v1/getXSell',
    xSellQaUrl:
      'https://nfd-adserver-bh.jarvisqa1k8s01.preprodapps.registeredsite.com/api/v1/getXSell',
    insightsTalkToOurTeamUrl: 'https://hostgator.tfaforms.net/575?',
    sharedHostingUrl:
      'https://www.hostgator.com/web-hosting?channelid=P61C100S1N0B3003A20D115E0000V100#pricing-cards',
    vpsHostingUrl:
      'https://www.hostgator.com/vps-hosting?channelid=P119C100S1N0B3003A20D115E0000V100#plan-table',
    dediHostingUrl:
      'https://www.hostgator.com/dedicated-server?channelid=P119C100S1N0B3003A20D115E0000V101#chooseThePlan',
    cloudHostingUrl: '',
    insightsArticleUrl:
      'https://www.hostgator.com/help/article/customer-portal-website-insights',
    usersArticleUrl:
      'https://www.hostgator.com/help/article/customer-portal-user-roles-permissions',
    xcitiumArticleUrl:
      'https://www.hostgator.com/help/article/hg-xcitium-backup-dashboard-guide',
    securityArticleUrl:
      'https://www.hostgator.com/help/article/customer-portal-manage-packages#security-tab',
    vpsOverviewArticleUrl:
      'https://www.hostgator.com/help/article/vps-general-information',
    dediOverviewArticleUrl:
      'https://www.hostgator.com/help/article/dedicated-server-getting-started-guide',
    gatorClawAiCreditArticleUrl:
      'https://www.hostgator.com/help/article/hg-connect-ai-credits-to-gatorclaw',
    openClawAiCreditArticleUrl:
      'https://www.hostgator.com/help/article/hg-connect-ai-credits-to-openclaw',
    claudeCodeAiCreditArticleUrl:
      'https://www.hostgator.com/help/article/hg-connect-ai-credits-to-claude-code',
    hermesAiCreditArticleUrl:
      'https://www.hostgator.com/help/article/hg-connect-ai-credits-to-hermes',
    nanoClawAiCreditArticleUrl:
      'https://www.hostgator.com/help/article/hg-connect-ai-credits-to-nanoclaw',
    purchaseAiCreditArticleUrl:
      'https://www.hostgator.com/help/article/hg-purchase-ai-credits',
    bluehostAPIKeysArticleUrl:
      'https://www.hostgator.com/help/article/hg-manage-and-create-api-keys',
    understandAiCreditArticleUrl:
      'https://www.hostgator.com/help/article/hg-understanding-ai-credits',
    aiModalCreditPricingArticleUrl:
      'https://www.hostgator.com/help/article/hg-ai-models-and-credit-pricing',
  },
  bluehost_in: {
    phoneNumberFormatted: '',
    phoneNumberHref: '',
    isDNSManagedInCpanel: true,
    domainName: 'www.bluehost.com',
    path: 'Bluehost%20Cloud',
    contactLink: 'https://www.bluehost.com/contact',
    renewalCenterLink: 'https://www.bluehost.com/my-account/billing-center-v2',
    optimizeLink:
      'https://www.bluehost.com/help/article/optimize-hosting-reduce-disk-space',
    supportLink: 'https://www.bluehost.com/contact',
    wpSolutionLearnMoreUrl: 'https://www.bluehost.com',
    loggingInUsingExtClient:
      'https://www.bluehost.com/help/article/ssh-connections',
    basicSSHCommands: 'https://www.bluehost.com/help/article/ssh-commands',
    commonSSHErrors: 'https://www.bluehost.com/help/article/common-ssh-errors',
    generateSSHPublicKeyUrl:
      'https://www.bluehost.com/help/article/generate-ssh-keys#windows-with-putty',
    indexesLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-index-manager',
    directoryPrivacyLearnMoreUrl:
      'https://www.bluehost.com/help/article/password-protect-a-folder-on-your-website',
    redirectsLearnMoreUrl:
      'https://www.bluehost.com/help/article/redirect-a-domain',
    diskUsageLearnMoreUrl:
      'https://www.bluehost.com/help/article/disk-space-bandwidth-usage',
    phpInfoLearnMoreUrl: 'https://www.bluehost.com/help/article/am-php-info',
    dbInfoLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-database-manager#create-mysql-db',
    cronJobLearnMoreUrl:
      'https://www.bluehost.com/help/article/cron-job-basics',
    remoteMySQLLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-remote-mysql',
    ipblockerLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-ip-blocker',
    cloudStagingKb: 'https://www.bluehost.com/help/article/bh-cloud-staging',
    cloudStagingPromoteKb:
      'https://www.bluehost.com/help/article/bh-cloud-promoting-a-staging-site',
    cloudStagingDeleteKb:
      'https://www.bluehost.com/help/article/bh-cloud-remove-or-delete-a-staging-site',
    cloudCachingUrl: 'https://www.bluehost.com/help/article/bh-cloud-caching',
    ftpLearnMoreUrl:
      'https://www.bluehost.com/help/article/create-and-manage-ftp-accounts-for-your-website',
    cloudFlareKB: 'https://www.bluehost.com/help/article/cloudflare-enable-cdn',
    checkDatabaseLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-check-repair-and-optimize-database-in-account-manager',
    repairDatabaseLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-check-repair-and-optimize-database-in-account-manager',
    sslLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-how-to-manually-install-ssl-in-account-manager',
    visitorInfoLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-viewing-visitor-stats',
    pageSpeedInsightsLearnMoreKb:
      'https://www.bluehost.com/help/article/am-pagespeed-insights',
    emailAccountForwardersLearnMoreUrl:
      'https://www.bluehost.com/help/article/create-account-and-domain-forwarders',
    phpErrorLogLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-php-errors',
    hotLinkProtectionLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-hotlink-protection',
    removeWpStagingSiteLearnMoreUrl:
      'https://www.bluehost.com/help/article/uninstall-wordpress#remove-staging-site',
    advancedDNSManagementUrl: '',
    emailFiltersLearnMoreUrl: '',
    globalEmailFiltersLearnMoreUrl: '',
    repairDocrootMismatchLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-website-misconfiguration-error',
    whoIsLink: 'https://www.iana.org/whois',
    contactSupportRestoreUrl: 'https://www.bluehost.com/contact',
    emailDiskUsageLearnMoreUrl: '',
    fixFileOwnershipLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-fix-file-ownership',
    sitesCapabilitiesLearnMoreUrl:
      'https://www.bluehost.com/help/article/virtual-private-server-vps-hosting-prices',
    accessLogsLearnMoreUrl:
      'https://www.bluehost.com/help/article/am-access-logs',
    insightsArticleUrl:
      'https://www.bluehost.com/help/article/bh-portal-website-insights',
    insightsTalkToOurTeamUrl: 'https://www.bluehost.com/full-service-seo',
    marketPlaceUrl:
      'https://www.bluehost.com/web-hosting?channelid=P61C100S1N0B3003A151D115E0000V109#pricing-cards',
    xSellProdUrl: 'https://adam.bluehost.com/api/v1/getXSell',
    xSellQaUrl:
      'https://global-nfd-nfd-adserver-bh.apps.atlanta1.newfoldmb.com/api/v1/getXSell',
    spamFiltersLearnMoreUrl:
      'https://www.bluehost.com/help/article/spam-filters',
    sharedHostingUrl: 'https://www.bluehost.com/hosting/shared',
    vpsHostingUrl: 'https://www.bluehost.com/hosting/vps',
    dediHostingUrl: 'https://www.bluehost.com/hosting/dedicated',
    cloudHostingUrl: 'https://www.bluehost.com/hosting/cloud',
    aiSiteUpgradeUrl: 'https://www.bluehost.com/checkout/ai-builder/publish',
    aiSiteArticleUrl:
      'https://www.bluehost.com/help/article/video-bh-ai-website-builder-tutorials',
    aiStoreArticleUrl:
      'https://www.bluehost.com/help/article/bh-ai-store-navigate-dashboard',
    aiSitePurchaseUrl: 'https://www.bluehost.com/ai-website-builder',
    aiStorePurchaseUrl: 'https://www.bluehost.com/ai-store',
    gatorClawAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-connect-ai-credits-to-gatorclaw',
    openClawAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-connect-ai-credits-to-openclaw',
    claudeCodeAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-connect-ai-credits-to-claude-code',
    hermesAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-connect-ai-credits-to-hermes',
    nanoClawAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-connect-ai-credits-to-nanoclaw',
    purchaseAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-purchase-ai-credits',
    bluehostAPIKeysArticleUrl:
      'https://www.bluehost.com/help/article/bh-manage-and-create-api-keys',
    understandAiCreditArticleUrl:
      'https://www.bluehost.com/help/article/bh-understanding-ai-credits',
    aiModalCreditPricingArticleUrl:
      'https://www.bluehost.com/help/article/bh-ai-models-and-credit-pricing',
  },
};
export const SubBrandIdData = {
  India: 269,
  UnitedStates: 264,
};
export const useBrandInfo = () => {
  // @ts-expect-error
  const { brand, brandFromJWT, SubBrandId: subBrandId } = useMFEContext();

  let brandLowerCase = brand
    ?.toLowerCase()
    .replace(/\s+/g, '') as keyof typeof brands;

  if (brandLowerCase === 'bluehost' && subBrandId === SubBrandIdData.India) {
    brandLowerCase = 'bluehost_in';
  }

  const brandExists = brandLowerCase && brandLowerCase in brands;

  return {
    /** Display-ready brand name (e.g. "Bluehost", "HostGator"). */
    localizedBrandName: brand,
    brandFromJWT,
    hostApplication: 'accountmanager',
    // TODO: BHENG-4400 remove isDreamscape once Dreamscape branches are deleted.
    isDreamscape: false,
    ...(brandExists
      ? // Use defaults first, but overwrite with actual brand values if defined
        { ...brands.default, ...brands[brandLowerCase] }
      : brands.default),
  };
};
